import { createContext, useContext } from 'react';
import { FooterTypes } from '..';

const defaultTheme: FooterTypes.TThemeModes = 'light';

export const ThemeContext =
  createContext<FooterTypes.TThemeModes>(defaultTheme);

export const useThemeContext = () => useContext(ThemeContext);
